module.exports = __webpack_public_path__ + "9b5262f2bcfd1ee8adc3cfc4b8c2e98e.svg";